import { render, staticRenderFns } from "./ListaAseguradoras.vue?vue&type=template&id=4863f1bb&scoped=true&"
import script from "./ListaAseguradoras.vue?vue&type=script&lang=js&"
export * from "./ListaAseguradoras.vue?vue&type=script&lang=js&"
import style0 from "./ListaAseguradoras.vue?vue&type=style&index=0&id=4863f1bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4863f1bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCardText,VCardTitle,VCheckbox,VCol,VImg,VRow,VSwitch})
